import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { getCustomers, setCustomerCreateRequestField, setCustomerUpdateRequestField } from '../../../pages/clienti/feature/slice';
import { setClientType, setOnSettingClientTypology, setOperatorGroup } from "../../../pages/clienti/slice";
import RadioButtonGroup from "../../molecules/RadioButtonGroup";
import { MadfarmStaticSelect } from '../../molecules/select/newSelect/static';
import './style.scss';

interface Props {
    disableRadio?: boolean
    mode?: "create" | "edit"
}

registerLocale('it', it)

enum CustomOptionsTypeCustomer {
    SINGLE = 'SINGOLO',
    GROUP = 'GRUPPO_DI_OPERATORI',
}

enum CustomOptionsTypeMemberCustomer {
    LEADER = 'CAPOFILA',
    MEMBER = 'MEMBRO',
}


export function ClientTypology(props: Props) {
    const [capoFilaDisabled, setCapoFilaDisabled] = useState<boolean>(true)
    const [groupTypeDisabled, setGroupTypeDisabled] = useState<boolean>(true)
    const [selectedTipologiaOption, setSelectedTipologiaOption] = useState<CustomOptionsTypeCustomer | null>(null);
    const [selectedTipologiaGroupOption, setSelectedTipologiaGroupOption] = useState<CustomOptionsTypeMemberCustomer | null>(null);
    const [groupLeadersOptions, setGroupLeadersOptions] = useState<{ value: string, label: string }[]>([])

    const customerState = useAppSelector(state => state.customer)
    const dispatch = useAppDispatch()

    const handleOptionTypeCustomerChange = (value: CustomOptionsTypeCustomer) => {
        setSelectedTipologiaOption(value);
        if (value === 'GRUPPO_DI_OPERATORI') {
            setClientType('GRUPPO_DI_OPERATORI')
            if (props.mode === "create")
                dispatch(setCustomerCreateRequestField({ field: 'clientType', value: 'GRUPPO_DI_OPERATORI' }))
            setGroupTypeDisabled(false)
        }
        else if (value === CustomOptionsTypeCustomer.SINGLE) {
            setClientType('SINGOLO')
            if (props.mode === "create")
                dispatch(setCustomerCreateRequestField({ field: 'clientType', value: 'SINGOLO' }))
            setSelectedTipologiaGroupOption(null);
            setGroupTypeDisabled(true)
            setCapoFilaDisabled(true)
        }

    };

    useEffect(() => {
        dispatch(setOnSettingClientTypology(true))
        dispatch(getCustomers({
            operatorsGroup: CustomOptionsTypeMemberCustomer.LEADER,
            itemsPerPage: 0,
            page: 0,
            headquarterId: null,
            active: null,
            order: false,
            norm: null,
            companyName: null,
            search: null
        }))
    }, [selectedTipologiaGroupOption])

    useEffect(() => {
        if (customerState.findAllCustomersResponse &&
            customerState.findAllCustomersResponse !== undefined &&
            customerState.findAllCustomersStatus === 'successfully'
        ) {
            dispatch(setOnSettingClientTypology(false))
            for (const customer of customerState.findAllCustomersResponse.data) {

                if (groupLeadersOptions.filter(o => o.value === customer.id).length > 0)
                    return;

                const newOption = {
                    value: customer.id,
                    label: `${customer.id} - ${customer.companyName}`
                };

                if (customer.operatorsGroup === CustomOptionsTypeMemberCustomer.LEADER) {
                    const currentLeaderGroup = groupLeadersOptions
                    currentLeaderGroup.push(newOption)
                    setGroupLeadersOptions([...currentLeaderGroup])
                }
            }
        }
    }, [customerState.findAllCustomersStatus])


    useEffect(() => {
        if (customerState.getCustomerByIdResponse !== undefined) {
            const clientType = customerState.getCustomerByIdResponse.clientType as CustomOptionsTypeCustomer;
            const operatorsGroup = customerState.getCustomerByIdResponse.operatorsGroup as CustomOptionsTypeMemberCustomer;
            if (clientType === CustomOptionsTypeCustomer.GROUP)
                setGroupTypeDisabled(false)
            dispatch(setClientType(clientType));
            dispatch(setOperatorGroup(customerState.getCustomerByIdResponse.operatorsGroup));
            setSelectedTipologiaOption(clientType);
            setSelectedTipologiaGroupOption(operatorsGroup)

        }
    }, [customerState.getCustomerByIdResponse]);


    const handleOptionGroupTypeChange = (value: CustomOptionsTypeMemberCustomer) => {
        setSelectedTipologiaGroupOption(value);
        if (value === 'MEMBRO') {
            setCapoFilaDisabled(false)
            dispatch(setOperatorGroup('MEMBRO'))
        }
        else {
            setCapoFilaDisabled(true)
            dispatch(setOperatorGroup('CAPOFILA'))
        }

    };

    const customerEditOrCreate = props.mode === "create" ? customerState.customerCreateRequest : customerState.customerUpdateRequest

    return (
        <div className='flex flex-col gap-4'>
            {
                customerState.customerCreateErrors.clientType && (
                    <span className='text-left text-label-md font-semibold text-red-500'>Scegliere tipologia cliente</span>
                )
            }
            <RadioButtonGroup
                name={'customer_type'}
                options={Object.values(CustomOptionsTypeCustomer)}
                selectedValue={selectedTipologiaOption}
                onChange={handleOptionTypeCustomerChange}
                disabled={props.disableRadio}
                optionLabels={{
                    [CustomOptionsTypeCustomer.SINGLE]: 'Singola',
                    [CustomOptionsTypeCustomer.GROUP]: 'Gruppo di Operatori',
                }}
            />
            {!groupTypeDisabled && (
                <div className='flex flex-col gap-4'>
                    <RadioButtonGroup
                        options={Object.values(CustomOptionsTypeMemberCustomer)}
                        selectedValue={selectedTipologiaGroupOption}
                        name={'group_type'}
                        disabled={groupTypeDisabled}
                        onChange={handleOptionGroupTypeChange}
                        optionLabels={{
                            [CustomOptionsTypeMemberCustomer.LEADER]: 'Capofila',
                            [CustomOptionsTypeMemberCustomer.MEMBER]: 'Membro',
                        }}
                    />
                    <MadfarmStaticSelect
                        label='Seleziona Capofila'
                        noOptionsMessage=''
                        disabled={capoFilaDisabled}
                        placeholder={'Seleziona Capofila'}
                        options={groupLeadersOptions}
                        value={customerEditOrCreate.leaderId?.toString()}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            if (props.mode === "create") {
                                dispatch(setCustomerCreateRequestField({ field: 'leaderId', value: newValue }))
                            } else {
                                dispatch(setCustomerUpdateRequestField({ field: 'leaderId', value: newValue }))
                            }
                        }}
                    />
                </div>
            )}
        </div>

    )
}